<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Borang Acu</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 55%">Type</th>
                            <th style="width: 20%">ID Surat</th>
                            <th style="width: 20%"></th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id" >
                              <td class="text-center">{{index+1}}.</td>
                              <td>{{data.type}}</td>
                              <td>{{data.id}}</td>
                              <td class="text-center" >
                                <button class="btn bg-blue btn-xs waves-effect" title="Lihat Data" data-toggle="modal" data-target="#m_lihat_surat" @click="GetData(data.id, data.type, data.borang)">
                                    <i class="material-icons" >find_in_page</i>
                                </button>
                                &nbsp;
                                <button class="btn bg-light-green btn-xs waves-effect" title="Edit Data" data-toggle="modal" data-target="#m_edit_data" @click="GetData(data.id, data.type, data.borang)">
                                    <i class="material-icons" >create</i>
                                </button>
                                &nbsp;
                                <button @click="removeData(data.id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                    <i class="material-icons" >clear</i>
                                </button>   
                              </td>
                          </tr>
                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                         &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                         &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_tambah_data" role="dialog" data-keyboard="false" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                    </div>
                                    <div class="modal-body">
                                        <span class="h_title">Type Surat</span>
                                        <input type="text" v-model="type" class="form-control padding-input">
                                        <br>
                                        <div>
                                            <span class="h_title">Isi Surat</span>
                                            <textarea v-model="isi" id="editor1"></textarea>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-light-green">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                    </div>
                                    <div class="modal-body">
                                        <span class="h_title">Type Surat</span>
                                        <input type="text" v-model="type" class="form-control padding-input">
                                        <br>
                                        <div>
                                            <span class="h_title">Isi Surat</span>
                                            <textarea v-model="isi" id="editor2"></textarea>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button @click="editData" type="button" class="btn btn-success waves-effect">EDIT</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <div class="modal fade" id="m_lihat_surat" role="dialog">
                            <div class="modal-dialog modal-lg" role="document">
                                <div class="modal-content">
                                    <div class="modal-header bg-blue">
                                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                                        <h4 class="modal-title" id="largeModalLabel">TEMPLATE BORANG</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <span>
                                                    <div v-html="isi"></div>
                                                </span>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <!-- <button @click="addData" type="button" class="btn btn-info waves-effect">SIMPAN</button> -->
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT SURAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
  
                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>
    // var aa = CKEDITOR.instances.editor1.getData()
    const ADD_URL = URL_APP+'api/v1/office_borang_acu/';


    export default {
    name: "borang_acu",
    data() {
        return {
            id : '',
            isi : '',
            type : '',
            
            list_data: [],
            page_first: 1,
            page_last: 0,
            cari_value: ""
        };
    },

    // =============================================================== METHODS =========================================================================
    methods : {
        getView: function() {
            fetch(ADD_URL + "view", {
                method: "POST",
                headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
                },
                body: JSON.stringify({
                data_ke: this.page_first,
                cari_value: this.cari_value
                })
            })
                .then(res => res.json())
                .then(res_data => {
                this.list_data = res_data.data;
                this.page_last = res_data.jml_data;
                // console.log(res_data);
            });
        },
        addData : function(){
            fetch (ADD_URL+'addData', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    type : this.type,
                    borang : CKEDITOR.instances.editor1.getData(),
                })
            }).then((res_data)=>{
                this.alertku("success", "sukses menambah data");
                this.getView();
            });
        },
        editData : function(){

            fetch(ADD_URL+'editData', {
                method : 'POST',
                headers : {
                    "content-type": "application/json",
                    authorization : 'kikensbatara '+ localStorage.token
                },
                body : JSON.stringify({
                    id : this.id,
                    type : this.type,
                    borang : CKEDITOR.instances.editor2.getData(),
                })
            }).then((res_data)=>{
                this.getView();
                this.alertku("success", "Sukses merubah data");
                // console.log(res_data);
            })
        },
        GetData : function(idnya, type, borang){
            this.id = idnya;
            this.type = type;
            this.isi = borang;
            CKEDITOR.instances.editor2.setData(borang);

            // alert(this.id);
        },
        removeData : function(idnya){
            fetch(ADD_URL + "removeData",{
                method : 'POST',
                headers : {
                   "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                },
                body : JSON.stringify({
                    id : idnya
                })
            }).then((res_data) => {
                this.alertku("success", "sukses menghapus data");
                this.getView();
                this.fileku = null;
            });
        },

        // ================== PAGINASI ====================
            alertku: function(type, title) {
            this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
            });
            },

            btn_prev: function() {
            if (this.page_first > 1) {
                this.page_first--;
            } else {
                this.page_first = 1;
            }
            this.getView();
            },

            btn_next: function() {
            if (this.page_first >= this.page_last) {
                this.page_first == this.page_last;
            } else {
                this.page_first++;
            }
                this.getView();
            },

            cari_data: function() {
                this.getView();
            },
        // ================== PAGINASI ====================
    },
    // =============================================================== METHODS =========================================================================

    mounted() {
        localStorage.sidemenu = 'office';
        this.getView();
        CKEDITOR.replace( 'editor1',{
            // width: 793.700787,
            height: 1122.519685,
        });

        CKEDITOR.replace( 'editor2',{
            // width: 793.700787,
            height: 1122.519685,
        });

        $(".pilih_unit").click(function(){
            // $("p").toggle();
            alert('bjquery')
        });
       
        var profile = JSON.parse(localStorage.profile);
        var unit_kerja = profile.profile.unit_kerja;  

    },

    };
</script>
